import { actions } from './owner_branches/actions'
import { getters } from './owner_branches/getters'
import { state } from './owner_branches/state'
import { mutations } from './owner_branches/mutations'

export default {
    namespaced: true,
    getters,
    state,
    mutations,
    actions
}